// extracted by mini-css-extract-plugin
export var submit = "styles-module--submit--3TCtO";
export var submitDark = "styles-module--submitDark--3Ai8P";